module.exports = __webpack_public_path__ + "static/media/ur.ab3cd842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/ur.png
// module id = 909
// module chunks = 0